var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"wrapper",attrs:{"type":"flex","align":"middle","justify":"center"}},[_c('a-col',{attrs:{"xs":24,"md":14,"lg":6}},[_c('logo-svg',{staticClass:"logo"}),_c('div',{staticClass:"box"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }